export const initialise = () => {
  addPlaceHolderResourceToEmailField();
};

const addPlaceHolderResourceToEmailField = () => {
  const emailField = document.querySelector<HTMLInputElement>(".edit-post-alert__email");
  if (emailField) {
    emailField.placeholder = "{{js.post-alert.email.placeholder}}";
  }
};
